import { Breadcrumbs, Link, Typography } from "@material-ui/core";
import { NavigateNext } from "@material-ui/icons";
import React from "react";
// import { useSelector } from "react-redux";
import { Link as RouterLink, useLocation } from "react-router-dom";

import { webTitle } from "../../common/AppConstant";
// import { selector as authStoreSelector } from "../../store/AuthStore";

import { drawerItems } from "./DrawerItems";
import useStyles from "./useStyles";

/**
 * パンくずリストコンポーネント.
 *
 * @return {object} コンポーネント
 */
function BreadcrumbList() {
  // スタイル
  const styles = useStyles();

  // Location情報
  const location = useLocation();

  // パスからパス名リストを取得（例："/hoge/fuga" -> ["hoge", "fuga"]）
  const pathNames = location.pathname.split("/").filter((x) => x);

  // const {
  //   // リモート保守可能フラグ（true: 可能、false: 不可能）
  //   isRemoteMaintenance,
  // } = useSelector(authStoreSelector);

  return (
    <Breadcrumbs
      className={styles.breadcrumbs}
      separator={<NavigateNext fontSize="small" />}
    >
      <Link component={RouterLink} color="inherit" to="/">
        {webTitle}
      </Link>
      {
        // パンくずリストを生成
        pathNames.map((value, index) => {
          // 最後のパスかどうか（ture: 最後、false: 最後ではない）
          const isLast = index === pathNames.length - 1;
          // リンク先のパスを生成
          const to = `/${pathNames.slice(0, index + 1).join("/")}`;
          // パス情報一覧からリンク先と同じパスのパス情報を取得
          let pathInfo = null;
          Object.keys(drawerItems).forEach((route) => {
            if (drawerItems[route].path === to) {
              pathInfo = drawerItems[route];
            }
          });
          if (!pathInfo) {
            // パス情報が存在しない場合はパンくずに何も表示しない
            return null;
          }
          return isLast ? (
            // 最後のパスの場合はラベルのパンくず
            <Typography color="textPrimary" key={pathInfo.id}>
              {pathInfo.name}
            </Typography>
          ) : (
            // 最後のパスでなはい場合はリンクのパンくず
            <Link
              component={RouterLink}
              color="inherit"
              to={to}
              key={pathInfo.id}
            >
              {pathInfo.name}
            </Link>
          );
        })
      }
    </Breadcrumbs>
  );
}

export default BreadcrumbList;
